module.exports = __webpack_public_path__ + "static/government_banner-4261079242dc9caf86cd23cad2189651.png";